var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-423bf9ae": "",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 90",
    className: "iconLeft",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "e8dccce0-88c4-4942-b733-61fb25b29095",
    fill: "#FFF",
    transform: "matrix(6.1224488604322,0,0,6.1224488604322,76.98554470319644,-16.10203926705264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82 13.94L8.82 6.02L7.20 5.08L1.19 5.08L1.19 14.88L7.20 14.88ZM3.15 6.76L6.86 6.76L6.86 13.20L3.15 13.20ZM19.45 14.88L21.34 14.88L21.34 5.08L18.75 5.08L16.30 12.29L16.27 12.29L13.80 5.08L11.20 5.08L11.20 14.88L13.09 14.88L13.09 8.33L13.12 8.33L15.34 14.88L17.21 14.88L19.42 8.41L19.45 8.41ZM31.35 13.94L31.35 6.02L29.72 5.08L23.72 5.08L23.72 14.88L29.72 14.88ZM25.68 6.76L29.39 6.76L29.39 13.20L25.68 13.20ZM40.66 9.10L40.66 6.02L39.03 5.08L33.73 5.08L33.73 14.88L39.03 14.88L40.66 13.94L40.66 10.53L39.44 9.83L39.44 9.80ZM35.69 10.65L38.70 10.65L38.70 13.20L35.69 13.20ZM35.69 6.76L38.70 6.76L38.70 8.97L35.69 8.97Z"
  }))), /*#__PURE__*/React.createElement("defs", {
    "data-v-423bf9ae": ""
  }, /*#__PURE__*/React.createElement("linearGradient", {
    "data-v-423bf9ae": "",
    gradientTransform: "rotate(25)",
    id: "fb104478-88c8-4b62-a59e-062f3bef73f4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "0%",
    style: {
      stopColor: "rgb(235, 110, 0)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    "data-v-423bf9ae": "",
    offset: "100%",
    style: {
      stopColor: "rgb(243, 188, 230)",
      stopOpacity: 1
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-v-423bf9ae": "",
    id: "c4a960df-b246-47f6-a11a-b132c5c020f8",
    transform: "matrix(2.8125,0,0,2.8125,-12.426001459360123,0)",
    stroke: "none",
    fill: "url(#fb104478-88c8-4b62-a59e-062f3bef73f4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.377 11.377L16 0 4.623 11.377 16 22.753l11.377-11.376zM16 6.026l5.35 5.35L16 16.727l-5.35-5.35L16 6.026zM27.426 14.969l-5.664 5.664V32h5.664zM10.238 20.633l-5.664-5.664V32h5.664z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f25c39dc0546d06f7accb44f57731c89.svg";
export { ForwardRef as ReactComponent };